import _regeneratorRuntime from "/home/jonsun/spot-frontend/node_modules/@babel/runtime/regenerator";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(getRequestInstance),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(sendRequest),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(cancelSendRequestOnAction),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchRequests);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { call, fork, join, take, race, cancel, put, all, cancelled, getContext, setContext } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { success, error, abort, successAction, errorAction, abortAction } from './actions';
import { REQUESTS_CONFIG, INCORRECT_PAYLOAD_ERROR } from './constants';
import { getActionPayload, isRequestAction } from './helpers';
export var voidCallback = function voidCallback() {};
export var defaultConfig = {
  driver: null,
  success: success,
  error: error,
  abort: abort,
  successAction: successAction,
  errorAction: errorAction,
  abortAction: abortAction,
  onRequest: null,
  onSuccess: null,
  onError: null,
  onAbort: null
};
export function createRequestInstance(config) {
  return setContext(_defineProperty({}, REQUESTS_CONFIG, _extends({}, defaultConfig, config)));
}
export function getRequestsConfig() {
  return getContext(REQUESTS_CONFIG);
}
export function getRequestInstance() {
  var driverType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var config, driver;
  return _regeneratorRuntime.wrap(function getRequestInstance$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getRequestsConfig();

        case 2:
          config = _context.sent;
          driver = driverType ? config.driver[driverType] : config.driver.default || config.driver;
          return _context.abrupt('return', driver.requestInstance);

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

var getDriver = function getDriver(requestsConfig, action) {
  return action.meta && action.meta.driver ? requestsConfig.driver[action.meta.driver] : requestsConfig.driver.default || requestsConfig.driver;
};

export function sendRequest(action) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$dispatchRequestA = _ref.dispatchRequestAction,
      dispatchRequestAction = _ref$dispatchRequestA === undefined ? false : _ref$dispatchRequestA,
      _ref$silent = _ref.silent,
      silent = _ref$silent === undefined ? false : _ref$silent,
      _ref$runOnRequest = _ref.runOnRequest,
      runOnRequest = _ref$runOnRequest === undefined ? true : _ref$runOnRequest,
      _ref$runOnSuccess = _ref.runOnSuccess,
      runOnSuccess = _ref$runOnSuccess === undefined ? true : _ref$runOnSuccess,
      _ref$runOnError = _ref.runOnError,
      runOnError = _ref$runOnError === undefined ? true : _ref$runOnError,
      _ref$runOnAbort = _ref.runOnAbort,
      runOnAbort = _ref$runOnAbort === undefined ? true : _ref$runOnAbort;

  var requestsConfig, driver, actionPayload, abortSource, response, responseError, _ref2, onErrorResponse, onErrorError, errorPayload, successPayload;

  return _regeneratorRuntime.wrap(function sendRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (isRequestAction(action)) {
            _context2.next = 2;
            break;
          }

          throw new Error(INCORRECT_PAYLOAD_ERROR);

        case 2:
          _context2.next = 4;
          return getRequestsConfig();

        case 4:
          requestsConfig = _context2.sent;

          if (!(dispatchRequestAction && !silent)) {
            _context2.next = 8;
            break;
          }

          _context2.next = 8;
          return put(action);

        case 8:
          _context2.next = 10;
          return call(getDriver, requestsConfig, action);

        case 10:
          driver = _context2.sent;
          actionPayload = getActionPayload(action);

          if (!(requestsConfig.onRequest && runOnRequest)) {
            _context2.next = 16;
            break;
          }

          _context2.next = 15;
          return call(requestsConfig.onRequest, actionPayload.request, action);

        case 15:
          actionPayload.request = _context2.sent;

        case 16:
          abortSource = driver.getAbortSource();
          _context2.prev = 17;
          response = void 0;
          responseError = void 0;
          _context2.prev = 20;

          if (Array.isArray(actionPayload.request)) {
            _context2.next = 27;
            break;
          }

          _context2.next = 24;
          return call([driver, 'sendRequest'], actionPayload.request, abortSource, action);

        case 24:
          response = _context2.sent;
          _context2.next = 30;
          break;

        case 27:
          _context2.next = 29;
          return all(actionPayload.request.map(function (requestItem) {
            return call([driver, 'sendRequest'], requestItem, abortSource, action);
          }));

        case 29:
          response = _context2.sent;

        case 30:
          _context2.next = 35;
          break;

        case 32:
          _context2.prev = 32;
          _context2.t0 = _context2['catch'](20);
          responseError = _context2.t0;

        case 35:
          if (!responseError) {
            _context2.next = 51;
            break;
          }

          if (!(requestsConfig.onError && runOnError)) {
            _context2.next = 43;
            break;
          }

          _context2.next = 39;
          return call(requestsConfig.onError, responseError, action);

        case 39:
          _ref2 = _context2.sent;
          onErrorResponse = _ref2.response;
          onErrorError = _ref2.error;

          if (onErrorResponse) {
            response = onErrorResponse;
          } else {
            responseError = onErrorError;
          }

        case 43:
          if (response) {
            _context2.next = 51;
            break;
          }

          _context2.next = 46;
          return call(driver.getErrorPayload, responseError);

        case 46:
          errorPayload = _context2.sent;

          if (silent) {
            _context2.next = 50;
            break;
          }

          _context2.next = 50;
          return put(_extends({
            type: requestsConfig.error(action.type)
          }, requestsConfig.errorAction(action, errorPayload)));

        case 50:
          return _context2.abrupt('return', {
            error: responseError
          });

        case 51:
          if (!(requestsConfig.onSuccess && runOnSuccess)) {
            _context2.next = 55;
            break;
          }

          _context2.next = 54;
          return call(requestsConfig.onSuccess, response, action);

        case 54:
          response = _context2.sent;

        case 55:
          _context2.next = 57;
          return call(driver.getSuccessPayload, response, actionPayload.request);

        case 57:
          successPayload = _context2.sent;

          if (silent) {
            _context2.next = 61;
            break;
          }

          _context2.next = 61;
          return put(_extends({
            type: requestsConfig.success(action.type)
          }, requestsConfig.successAction(action, successPayload)));

        case 61:
          return _context2.abrupt('return', {
            response: response
          });

        case 62:
          _context2.prev = 62;
          _context2.next = 65;
          return cancelled();

        case 65:
          if (!_context2.sent) {
            _context2.next = 74;
            break;
          }

          _context2.next = 68;
          return call([driver, 'abortRequest'], abortSource);

        case 68:
          if (!(requestsConfig.onAbort && runOnAbort)) {
            _context2.next = 71;
            break;
          }

          _context2.next = 71;
          return call(requestsConfig.onAbort, action);

        case 71:
          if (silent) {
            _context2.next = 74;
            break;
          }

          _context2.next = 74;
          return put(_extends({
            type: requestsConfig.abort(action.type)
          }, requestsConfig.abortAction(action)));

        case 74:
          return _context2.finish(62);

        case 75:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[17,, 62, 75], [20, 32]]);
}

var isGetRequest = function isGetRequest(request) {
  return !request.method || request.method.toLowerCase() === 'get';
};

var watchRequestsDefaultConfig = {
  takeLatest: function takeLatest(action) {
    var _getActionPayload = getActionPayload(action),
        request = _getActionPayload.request;

    return Array.isArray(request) ? request.every(isGetRequest) : isGetRequest(request);
  },
  abortOn: null,
  getLastActionKey: function getLastActionKey(action) {
    return action.type;
  }
};
export function cancelSendRequestOnAction(abortOn, task) {
  var _ref3, abortingAction;

  return _regeneratorRuntime.wrap(function cancelSendRequestOnAction$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return race({
            abortingAction: take(abortOn),
            taskFinished: join(task),
            timeout: call(delay, 10000) // taskFinished doesnt work for aborted tasks

          });

        case 2:
          _ref3 = _context3.sent;
          abortingAction = _ref3.abortingAction;

          if (!abortingAction) {
            _context3.next = 7;
            break;
          }

          _context3.next = 7;
          return cancel(task);

        case 7:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}
export function watchRequests() {
  var common = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var perRequestType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var lastTasks, config, action, localConfig, lastActionKey, takeLatest, activeTask, newTask;
  return _regeneratorRuntime.wrap(function watchRequests$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          lastTasks = {};
          config = _extends({}, watchRequestsDefaultConfig, common);

        case 2:
          if (!true) {
            _context4.next = 23;
            break;
          }

          _context4.next = 5;
          return take(isRequestAction);

        case 5:
          action = _context4.sent;
          localConfig = perRequestType[action.type] ? _extends({}, config, perRequestType[action.type]) : config;
          lastActionKey = localConfig.getLastActionKey(action);
          takeLatest = typeof localConfig.takeLatest === 'function' ? localConfig.takeLatest(action) : localConfig.takeLatest;

          if (!takeLatest) {
            _context4.next = 14;
            break;
          }

          activeTask = lastTasks[lastActionKey];

          if (!activeTask) {
            _context4.next = 14;
            break;
          }

          _context4.next = 14;
          return cancel(activeTask);

        case 14:
          _context4.next = 16;
          return fork(sendRequest, action);

        case 16:
          newTask = _context4.sent;

          if (takeLatest) {
            lastTasks[lastActionKey] = newTask;
          }

          if (!localConfig.abortOn) {
            _context4.next = 21;
            break;
          }

          _context4.next = 21;
          return fork(cancelSendRequestOnAction, localConfig.abortOn, newTask);

        case 21:
          _context4.next = 2;
          break;

        case 23:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}